module.exports = __webpack_public_path__ + "static/media/trigger.2f8454bf.svg";